export default {
  title: 'Acord',
  description: 'Vi se va percepe suma de {{amount}} pe lună dacă nu anulați perioada de probă.',
  bill_at_launch_date: 'Prima factură la data lansării',
  bill_date: 'Data facturării: {{date}}',
  bill_date_after_launch: 'Prima dată de facturare: {{days}} zile după lansare',
  sign_agreement: 'Vă rugăm să semnați acordul de abonament și participare la platformă',
  restaurant: 'Restaurant',
  agreement:
    'Sunt de acord cu <a href="{{terms_url}}" target="_blank" rel="noreferrer noopener">termenii platformei</a>. Pot anula abonamentul oricând notificând {{provider}}. Abonamentul va fi anulat și acordul de plată revocat imediat ce Restaurantul contactează {{provider}} prin e-mail sau WhatsApp. Nu se vor mai percepe taxe ulterior. Sunt de acord că consimțământul meu electronic este echivalent cu semnarea acestui document și înțeleg că semnătura mea electronică este obligatorie.',
};
